import { Injectable } from '@angular/core';
import { HttpBackend, HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { catchError, switchMap } from 'rxjs/operators';
import { errorHandl } from 'src/app/utils/network-utils';
import { PlacementAuthService } from '../placement-auth-service/placement-auth.service';

@Injectable({
  providedIn: 'root'
})
export class MessagesService {
  private http: HttpClient;

  constructor(private handler: HttpBackend, private placementAuthService: PlacementAuthService) {
    this.http = new HttpClient(handler);
  }

  getThread(reservationId: number | string): Observable<any> {
    return this.placementAuthService.login().pipe(
      switchMap(token => {
        const headers = new HttpHeaders({
          'Authorization': `Bearer ${token}`
        });
        return this.http.post<any>(
          this.placementAuthService.baseUrl + '/messages-contacts/thread/' + reservationId,
          {},
          { headers }
        );
      }),
      catchError(errorHandl)
    );
  }

  getMessagesContacts(): Observable<any> {
    return this.placementAuthService.login().pipe(
      switchMap(token => {
        const headers = new HttpHeaders({
          'Authorization': `Bearer ${token}`
        });
        return this.http.get<any>(
          this.placementAuthService.baseUrl + '/messages-contacts',
          { headers }
        );
      }),
      catchError(errorHandl)
    );
  }

  getMessages(onboardingId: number | string, recipientId: number | string): Observable<any> {
    return this.placementAuthService.login().pipe(
      switchMap(token => {
        const headers = new HttpHeaders({
          'Authorization': `Bearer ${token}`
        });
        const params = new HttpParams().set('recipient_id', String(recipientId));
        return this.http.get<any>(
          this.placementAuthService.baseUrl + '/messages-contacts/' + onboardingId,
          { headers, params }
        );
      }),
      catchError(errorHandl)
    );
  }

  sendMessage(onboardingId: number | string, recipientId: number | string, encryptedMessage: string): Observable<any> {
    return this.placementAuthService.login().pipe(
      switchMap(token => {
        const headers = new HttpHeaders({
          'Authorization': `Bearer ${token}`
        });
        const payload = {
          recipient_id: Number(recipientId),
          message: encryptedMessage
        };
        return this.http.post<any>(
          this.placementAuthService.baseUrl + '/messages-contacts/' + onboardingId,
          payload,
          { headers }
        );
      }),
      catchError(errorHandl)
    );
  }
}
